import "@tomprats/font-awesome-pro/js/all";
import "core-js/stable";
import {useMemo, useReducer} from "react";
import {RouterProvider} from "react-router-dom";
import "regenerator-runtime/runtime";
import Context from "app/context";
import Reducer, {createInitialState} from "app/reducer";
import createRouter from "app/router";
import useScrollbarWidth from "lib/hooks/use-scrollbar-width";

window.FontAwesome.config.autoReplaceSvg = "nest";

export default function Application(props) {
  const [reducer, dispatch] = useReducer(Reducer, props, createInitialState);
  const state = useMemo(() => ({...reducer, dispatch}), [reducer, dispatch]);
  const router = useMemo(() => createRouter(state), [!!state.user]);

  useScrollbarWidth();

  return (
    <Context.Provider value={state}>
      <RouterProvider router={router} />
    </Context.Provider>
  );
}
